import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import { Box, Typography, Paper } from '@mui/material';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { inventoryService } from '../services/inventory.service';

const InventorySkuLot = () => {
  const { sku, lot } = useParams();
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);

  const [columnDefs] = useState([
    { field: 'warehouse_name', headerName: 'Warehouse', flex: 1 },
    { field: 'description', headerName: 'Product', flex: 1 },
    { field: 'sku', headerName: 'SKU', width: 120 },
    { field: 'lot_number', headerName: 'Lot', width: 120 },
    { field: 'quantity', headerName: 'Quantity', width: 120, type: 'numericColumn' },
    { field: 'area', headerName: 'Area', width: 130 },
    { field: 'zone', headerName: 'Zone', width: 130 },
    { field: 'bin_location', headerName: 'Bin', width: 130 },
    { 
      field: 'expiration_date', 
      headerName: 'Expiration', 
      width: 130,
      sort: 'asc'
    }
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Using inventoryService instead of direct fetch
        const data = await inventoryService.getInventoryByLot(lot, sku);
        
        if (data.status === 'success') {
          // Set summary data
          setSummary({
            total_quantity: data.inventory_data.total_quantity,
            warehouse_count: data.inventory_data.warehouse_count
          });

          // Transform data for AG Grid
          const inventoryRows = Object.entries(data.inventory_data.inventory_data).map(([warehouseId, warehouse]) => ({
            warehouse_name: warehouse.warehouse_name,
            ...warehouse.items[0]  // Spread the first (and only) item's properties
          }));
          
          setRowData(inventoryRows);
        } else {
          throw new Error('API returned error status');
        }
      } catch (error) {
        console.error('Error fetching inventory data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sku, lot]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Inventory for SKU: {sku}, Lot: {lot}
        </Typography>
        {summary && (
          <Typography variant="body1" color="text.secondary">
            Total Quantity: {summary.total_quantity.toLocaleString()} units across {summary.warehouse_count} warehouses
          </Typography>
        )}
      </Paper>
      
      <div 
        className="ag-theme-material"
        style={{ 
          height: '600px',
          width: '100%'
        }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={{
            sortable: true,
            filter: true,
            resizable: true,
          }}
          pagination={true}
          paginationPageSize={100}
        />
      </div>
    </Box>
  );
};

export default InventorySkuLot; 